// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BQ1Ph","learnMoreButton":"styles_learnMoreButton__ECEtU","fullView":"styles_fullView__FT6ru","shimmer":"styles_shimmer__xxvBX"};